import { useQuery } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';
import type {
  MtAnimalBuyerGetAnimalQuery,
  MtAnimalBuyerGetAnimalQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const MT_ANIMAL_BUYER_GET_ANIMAL = graphql(`
  query MtAnimalBuyerGetAnimal($animalsWhere: AnimalWhereInput) {
    accountMe {
      id
      animals(where: $animalsWhere, take: 1) {
        ...BuyerAnimalInfo
      }
    }
  }
`);

export const useGetAnimal = (id?: number) => {
  const { currentAccount } = useCurrentAccount();

  const variables = useMemo((): MtAnimalBuyerGetAnimalQueryVariables => {
    return {
      animalsWhere: { id: { equals: id ?? -1 } },
    };
  }, [id]);

  const { data, error, loading } = useQuery<
    MtAnimalBuyerGetAnimalQuery,
    MtAnimalBuyerGetAnimalQueryVariables
  >(MT_ANIMAL_BUYER_GET_ANIMAL, {
    variables,
    skip: id == null || currentAccount == null,
  });

  return {
    animal: data?.accountMe?.animals?.[0],
    animalError: error,
    animalLoading: loading,
    animalVariables: variables,
  };
};
